import { Grid, TextField } from "@mui/material";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import { styled } from '@mui/material/styles';


const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    color: theme.palette.text.primary,
  },
  '& label': {
    color: theme.palette.text.secondary,
  },
  '& label.Mui-focused': {
    color: theme.palette.info.main,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.grey[400],
    },
    '&:hover fieldset': {
      borderColor: theme.palette.grey[600],
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.info.main,
    },
  },
}));

function DepartmentForm({ formData, handleChange, companies }) {
  return (
    <MDBox py={3}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12}>
          <StyledTextField
            fullWidth
            label="اسم القسم"
            name="name"
            value={formData.name}
            onChange={(e) => handleChange({ ...formData, name: e.target.value })}
            required
            placeholder="أدخل اسم القسم"
          />
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            select
            fullWidth
            label="الشركة"
            name="companyId"
            value={formData.companyId}
            onChange={(e) => handleChange({ ...formData, companyId: e.target.value })}
            required
            SelectProps={{
              native: true,
              sx: {
                maxHeight: '200px',
                '& select': {
                  padding: '25.5px 14px',
                },
                '& option': {
                  padding: '10px',
                  fontSize: '0.875rem',
                }
              }
            }}
          >
            <option value="">اختر الشركة</option>
            {companies.map((company) => (
              <option key={company.id} value={company.id}>
                {company.name}
              </option>
            ))}
          </StyledTextField>
        </Grid>
        <Grid item xs={12}>
          <StyledTextField
            fullWidth
            label="الوصف"
            name="description"
            multiline
            rows={4}
            value={formData.description}
            onChange={(e) => handleChange({ ...formData, description: e.target.value })}
            placeholder="أدخل وصف القسم"
          />
        </Grid>
  
      </Grid>
    </MDBox>
  );
}

DepartmentForm.propTypes = {
  formData: PropTypes.shape({
    name: PropTypes.string,
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    description: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
};

export default DepartmentForm;
